<template lang="pug">
f7-page#login
  navbar(title="ログアウト")

  background-image
    p.page-title ログアウトしました
</template>

<style lang="scss" scoped>
.page-title {
  margin-top: 80px;
  text-align: center;
  @extend %pagetitle-text;
}
</style>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('auth', ['logout']),
    async logoutAndRedirect() {
      await this.logout()
      setTimeout(() => {
        location.href = 'curriculums'
        // this.$f7router.navigate('/curriculums', { animate: false })
      }, 3000)
    },
  },
  mounted() {
    this.logoutAndRedirect()
  },
}
</script>
